import isoLanguages from "@cospired/i18n-iso-languages";

let languages = [];

export const getLanguages = () => languages;
export const getLanguage = key => languages[key];

export const updateLanguages = locale => {
  try {
    const lang = locale.split("-")[0];
    isoLanguages.registerLocale(
      require(`@cospired/i18n-iso-languages/langs/${lang}.json`)
    );
    languages = isoLanguages.getNames(lang);
  } catch (err) {
    console.error(err);
  }
};
